import React, { useRef, useState } from 'react'
import { Box, Alert, Button } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import GenericDrawer from './GenericComponents/GenericDrawer'
import { fetchPostJobCSV } from 'src/redux/csv'

const JobCSVUploadDrawer = ({ open, onClose }) => {
  const dispatch = useDispatch()
  const fileInputRef = useRef(null)
  const [selectedFile, setSelectedFile] = useState(null)
  const [error, setError] = useState('')
  const [successMessage, setSuccessMessage] = useState('')
  const loading = useSelector(state => state.csv.loading)

  const handleFileChange = event => {
    const file = event.target.files[0]
    setError('')
    setSuccessMessage('')
    setSelectedFile(file || null)
  }

  const handleUpload = () => {
    if (!selectedFile) {
      setError('Please select a CSV file.')
      return
    }

    setError('')
    setSuccessMessage('')

    dispatch(fetchPostJobCSV(selectedFile))
      .then(response => {
        if (response && response.error) {
          setError(response.error)
        } else {
          setSuccessMessage('CSV uploaded successfully. Import is processing in the background.')
          setSelectedFile(null)
          if (fileInputRef.current) {
            fileInputRef.current.value = ''
          }
        }
      })
      .catch(() => {
        setError('An error occurred while uploading the CSV.')
      })
  }

  return (
    <GenericDrawer
      open={open}
      onClose={onClose}
      title='Upload CSV for Jobs'
      submitLabel='Close'
      cancelLabel='Cancel'
      onSubmit={onClose}
    >
      <Box>
        <input
          ref={fileInputRef}
          type='file'
          accept='.csv'
          onChange={handleFileChange}
        />

        <Box sx={{ mt: 2 }}>
          <Button
            variant='contained'
            onClick={handleUpload}
            disabled={loading || !selectedFile}
          >
            {loading ? 'Uploading...' : 'Upload'}
          </Button>
        </Box>

        {successMessage && (
          <Alert severity='success' sx={{ mt: 2 }}>
            {successMessage}
          </Alert>
        )}

        {error && (
          <Alert severity='error' sx={{ mt: 2 }}>
            {error}
          </Alert>
        )}
      </Box>
    </GenericDrawer>
  )
}

export default JobCSVUploadDrawer
